import script from "./form-quality.vue?vue&type=script&setup=true&lang=js"
export * from "./form-quality.vue?vue&type=script&setup=true&lang=js"

import "./form-quality.vue?vue&type=style&index=0&id=7f249dda&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f249dda"]])

export default __exports__